import React from 'react';
import { DisplayToggle } from '@components/shared';
import { ExploreMoreSection } from './ExplorePage/ExploreMoreSection';

export const NoResultsExplorePage = ({ searchInput }: { searchInput: string | null }) => {
  return (
    <div>
      <div className="flex flex-col gap-6 md:px-4">
        <div className="flex flex-col items-center gap-4 py-10">
          <p className="text-title text-center text-title-s font-medium md:text-title-l">
            {searchInput && (
              <DisplayToggle media="tablet"> No results for "{searchInput}"</DisplayToggle>
            )}
            <DisplayToggle media="notTablet"> No results found.</DisplayToggle>
          </p>
          <p className="font-base text-base-m md:text-base-l">
            If at first you don't succeed, try again.
          </p>
        </div>
        <ExploreMoreSection />
      </div>
    </div>
  );
};
